/**
 * @generated SignedSource<<cb3bd3918632b0406515e9628b12680c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSkillsFields_User$data = {
  readonly profile: {
    readonly industry: {
      readonly profilesRequireSkills: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly userSkills: ReadonlyArray<{
    readonly experience: number | null | undefined;
    readonly skill: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  }> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UserSkillsEditDialog_User">;
  readonly " $fragmentType": "UserSkillsFields_User";
};
export type UserSkillsFields_User$key = {
  readonly " $data"?: UserSkillsFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSkillsFields_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSkillsFields_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserSkillsEditDialog_User"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Industry",
          "kind": "LinkedField",
          "name": "industry",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilesRequireSkills",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSkill",
      "kind": "LinkedField",
      "name": "userSkills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "experience",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f9850532d6d337e06645f92c848ea8b5";

export default node;
